import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth from './auth';
import user from './user';
import admin from './admin'
import sales from './sales'
import drawer from './drawer'

const rootReducer = combineReducers({
    routing: routerReducer,
    auth,
    user,
    admin,
    sales,
    drawer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js